import React from "react";
// import $ from 'jquery';
import { connect } from "react-redux";

import Nav1 from "../../../components/Navigation/Nav1/Nav1";
import Question from "../../../components/Question/Question";
import Answers from "../../../components/Answers/Answers";

import LandingSet from "../../../libs/LandingSet";
import "./Panel.scss";

const Panel = (props) => {
  const classes = [
    "Panel",
    props.pnlIdx !== undefined ? `Panel--${props.pnlIdx}` : "",
    props.classAdd ? `Panel${props.classAdd}` : "",
  ];

  const nextTxt =
    props.pnlIdx + 1 === props.pnlsLen
      ? LandingSet.finishBtn[props.currentLang]
      : LandingSet.nextBtn[props.currentLang];

  return (
    <div className={classes.join(" ")}
    id={`Panel__${props.pnlIdx}`}
     >
      {props.children ? (
        <div
          className={`Panel__overlay ${
            props.classAdd === "__results"
              ? "Panel__overlay--x"
              : "Panel__overlay--1"
          }`}
   
        >
          <div className="Panel__wrapper Panel__wrapper--2">
            {props.children}
          </div>
        </div>
      ) : (
        <div className="Panel__overlay Panel__overlay--2">
          <Nav1
           text="Previous"
            clicked={props.pnlMvmtHnldr}
            label={`Back to ${props.prevLabel} Question `}
            retLnd={!props.pnlIdx}
            nextBtnIdx={props.pnlIdx !== undefined ? props.pnlIdx : null}
          />
          <div className="Panel__wrapper Panel__wrapper--1">
            <div className="Panel__header">{props.pnl.currH}</div>
            <Question q_id={`Question__${props.pnlIdx}`} question={props.pnl.currQ} />
            <Answers
              answers={props.pnl.currA}
              pnlIdx={props.pnlIdx}
              cv={props.pnl.currCV}
              groupLabel={`Question__${props.pnlIdx}`}
              changeHandlr={props.changeHandlr}
            />
          </div>
          <Nav1
            text={nextTxt}
            pnlID={props.pnlIdx + 1}
            type={1}
            nextBtnIdx={props.pnlIdx !== undefined ? props.pnlIdx : null}
            clicked={props.pnlMvmtHnldr}
            tabIndex={0}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentLang: state.langReducer.currentLang,
  };
};

export default connect(mapStateToProps, null)(Panel);
